import { load } from 'cheerio';
import { useNotificationStore } from '@/store/notificationStore';
import { useActiveUrlStore } from '@/store/activeUrlStore';
import Provider from '@/enums/Provider';

/**
 * Checks if the provided pathname matches the canonical URL in the HTML source.
 *
 * Some sites only provide the base URL in the og:url meta tag (e.g., "www.ijumpncitrus.com"),
 * meaning there is no specific pathname. In such cases, this function will return true.
 *
 * @param pathname - The original pathname used to fetch the URL.
 * @param htmlSource - The HTML source of the fetched page.
 * @returns true if the canonical pathname from the HTML matches the given pathname,
 * or if the canonical URL is just the base URL; false otherwise.
 *
 * @example
 * if (!isPathnameMatch('/rentals/tents', pageSourceHtml )) {
 *   // Handle the redirect or skip duplicate processing.
 * }
 */
export function isPathnameMatch(pathname: string, pageSourceHtml: string): boolean {
    const activeUrlStore = useActiveUrlStore();
    const provider = activeUrlStore.getProvider;
    const notificationStore = useNotificationStore();
    if (provider === Provider.IO) {


        try {
            const $ = load(pageSourceHtml);
            const ogUrl = $('meta[property="og:url"]').attr('content');
            if (ogUrl) {
                let canonicalUrl;
                try {
                    canonicalUrl = new URL(ogUrl, 'http://placeholder-base-url.com');
                } catch (e) {
                    notificationStore.addWarningNotification("Invalid og:url format, assuming base URL: " + ogUrl);
                    return true;
                }
                const canonicalPathname = canonicalUrl.pathname;
                // If the canonical URL only provides the base path, consider it valid.
                if (canonicalPathname === '/' || canonicalPathname === '') {
                    return true;
                }
                return canonicalPathname === pathname;
            }
        } catch (error) {
            notificationStore.addErrorNotification("Error checking canonical URL: " + error);
        }
    }
    // Fallback: If no meta tag is found or an error occurs, assume the pathname is valid.
    return true;
}
